export const AppointmentConstants = {
  STATUS: {
    ongoing: "ongoing",
    completed: "completed",
    scheduled: "scheduled",
    cancelled: "cancelled",
  },
};
